// assets/landing-page-v2.js
document.addEventListener('DOMContentLoaded', () => {
    // Set current year in footer
    // This might be part of your theme's footer, if so, this specific part can be removed.
    const currentYearElement = document.getElementById('currentYear');
    if (currentYearElement) {
        currentYearElement.textContent = new Date().getFullYear();
    }

    // Header scroll effect - This will apply to an element with id="header"
    // If your theme's header has a different ID or class, this needs adjustment or might be handled by your theme.
    const header = document.getElementById('header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }
    
    // Mobile navigation - This targets .nav-toggle, .nav, .nav-overlay
    // If you are using your theme's header and its mobile navigation, this JS block might be entirely unnecessary or conflict.
    // Please review based on your theme's header implementation.
    const navToggle = document.querySelector('.nav-toggle');
    const nav = document.querySelector('.nav');
    const navOverlay = document.querySelector('.nav-overlay');
    const body = document.body;

    if (navToggle && nav && navOverlay) {
        navToggle.addEventListener('click', () => {
            const isOpen = navToggle.classList.toggle('open');
            navToggle.setAttribute('aria-expanded', isOpen);
            nav.classList.toggle('open');
            navOverlay.classList.toggle('open');
            body.classList.toggle('nav-open');
        });
        
        navOverlay.addEventListener('click', closeNav);
        
        const navLinks = document.querySelectorAll('.nav-link'); // These are for the custom nav
        navLinks.forEach(link => {
            link.addEventListener('click', closeNav);
        });

        function closeNav() {
            if (navToggle && nav && navOverlay) { // Added null checks
                navToggle.classList.remove('open');
                navToggle.setAttribute('aria-expanded', 'false');
                nav.classList.remove('open');
                navOverlay.classList.remove('open');
                body.classList.remove('nav-open');
            }
        }
    }
    // END OF POTENTIALLY UNUSED MOBILE NAVIGATION JS
    
    // FAQ accordions
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        if (question) {
            question.addEventListener('click', () => {
                // const isActive = item.classList.contains('active'); // Not used
                // faqItems.forEach(otherItem => { // Removed to allow multiple open
                //     if (otherItem !== item) {
                //         otherItem.classList.remove('active');
                //     }
                // });
                item.classList.toggle('active');
            });
        }
    });
    
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === '#' || href.startsWith('#!') ) return; 

            const targetId = href.substring(1); 
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                e.preventDefault();
                // Try to get header height dynamically from your theme's header if possible
                // Or use a fixed offset if your theme's header height is consistent.
                let headerOffset = 80; // Default offset
                const siteHeader = document.querySelector('.shopify-section-header') || document.getElementById('header'); // Common selectors for Shopify headers
                if (siteHeader) {
                    headerOffset = siteHeader.offsetHeight;
                }
                
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                // Active state for nav links - this part is for the custom nav.
                // If using theme's nav, its active state logic will likely be different.
                // document.querySelectorAll('.nav-link.active').forEach(l => l.classList.remove('active'));
                // if(anchor.classList.contains('nav-link')) {
                //     anchor.classList.add('active');
                // } else {
                //     const correspondingNavLink = document.querySelector(`.nav-link[href="${href}"]`);
                //     if(correspondingNavLink) correspondingNavLink.classList.add('active');
                // }
            }
        });
    });
    
    // GSAP Animations - DELAYED & SIMPLIFIED FOR PERFORMANCE
    const initAnimations = () => {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);

            // --- Simplified High-Performance Animations ---

            // 1. Hero elements (these run immediately on load, which is fine)
            gsap.from(".hero h1, .hero .hero-subtitle, .hero .hero-cta", {
                opacity: 0,
                y: 30,
                duration: 0.8,
                stagger: 0.2,
                delay: 0.2,
                ease: 'power2.out'
            });

            // 2. Animate ONLY major section containers as they scroll into view
            const sectionsToAnimate = gsap.utils.toArray([
              '.lp2-logo-banner',
              '.lp2-problem-agitation',
              '.lp2-how-it-works',
              '.lp2-product-showcase',
              '.lp2-philosophy',
              '.lp2-advantage',
              '.lp2-bundle-offer',
              '.lp2-product-details',
              '.lp2-transformation',
              '.lp2-benefits',
              '.lp2-faq',
              '.lp2-final-cta'
            ]);

            sectionsToAnimate.forEach(section => {
              if (section) {
                // We target the section itself for the trigger, and a child container for the animation if it exists.
                const animationTarget = section.querySelector('.container') || section;
                gsap.from(animationTarget, {
                  opacity: 0,
                  y: 50,
                  duration: 1.0,
                  ease: 'power3.out',
                  scrollTrigger: {
                    trigger: section,
                    start: 'top 85%',
                    toggleActions: 'play none none none',
                    once: true
                  }
                });
              }
            });
        }
    }; // End of the initAnimations function

    // Delay the animation initialization until the browser is idle
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initAnimations, { timeout: 2000 });
    } else {
      setTimeout(initAnimations, 500); // Fallback for older browsers
    }
}); // This is the closing tag for the main 'DOMContentLoaded' event listener